import React from 'react';
import bem from 'utils/bem';

import './index.sass';

const { cnBlock } = bem('text');

const mods = [
    'uppercase',
    'italic',
    'bold',
    'extra-bold',
    'serif'
];

const Text = ({ className, tag: Tag = 'span', ...rest }) => {
    const validMods = Object.keys(rest).filter(x => mods.includes(x));
    const restPropsKeys = Object.entries(rest).filter(([key, _value]) => !mods.includes(key));
    const restProps = Object.fromEntries(restPropsKeys);
    return (
        <Tag className={ cnBlock(className, validMods) } { ...restProps } />
    );
};

export default Text;
